"use client";

import React, { useEffect, useState } from "react";

import { ButtonLink } from "@/components/ui/Button/Button";
import Image from "next/image";
import { event } from "@/helpers/gtag";
import { motion } from "framer-motion";
import styles from "./HeroBanner.module.css";
import { useTranslations } from "next-intl";

const HeroBanner = () => {
  const t = useTranslations("homepage");

  const [displayedText, setDisplayedText] = useState("");

  const headerText = t("header")?.trim() || "";

  useEffect(() => {
    if (!headerText || typeof headerText !== "string") {
      return;
    }

    let index = 0;

    const interval = setInterval(() => {
      if (index < headerText.length) {
        const nextChar = headerText[index];
        if (typeof nextChar !== "string") {
          clearInterval(interval);
          return;
        }

        setDisplayedText((prev) => prev + nextChar);
        index++;
      } else {
        clearInterval(interval);
      }
    }, 100); // Reduced from 100ms to 50ms for 50% faster animation

    return () => {
      clearInterval(interval);
    };
  }, [headerText]);

  return (
    <section className={styles.heroBanner}>
      <div className={styles.wrapper}>
        <motion.h1
          className={styles.mainHeading}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          {displayedText}
        </motion.h1>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
          className={styles.subheader}
        >
          {t("subheader")}
        </motion.p>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, ease: "easeOut", delay: 0.4 }}
          className={styles.cta}
        >
          <ButtonLink
            outline="outline"
            variant="secondary"
            href="https://store.boursa.io/5O4u/web"
            isExternal
            onClick={() => {
              event({
                action: "download_app_click",
                category: "engagement",
                label: "Download App Button - Home",
                value: 1,
              });
            }}
          >
            {t("downloadApp")}
          </ButtonLink>
        </motion.div>
        <motion.div
          className={styles.heroImageWrapper}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, ease: "easeOut" }} // Removed delay: 0.6 for immediate render
        >
          <Image
            src="/images/banner/home-banner.svg"
            alt="hero banner"
            width={963}
            height={569}
            className={styles.heroImage}
            priority
          />
        </motion.div>
      </div>
    </section>
  );
};

export default HeroBanner;
